





























































































































































































import { DateTime } from 'luxon'
import user_info from '../user_info'
import order_jobs from '../order_jobs'

export default {
  components:
    'user-info': user_info
    'order-jobs': order_jobs

  data: ->
    order_headers: [
      '',
      'Barcode',
      'Name',
      'Unit price',
      'Qty',
      'Total'
    ],
    order: null
    polling: false
    poll_timeout_id: null
    refund_action: null
    refund_message: null

  computed: {
    pending_refund: ->
      return null unless @order?.transactions

      for transaction in @order.transactions
        refund = transaction.refunds?.find (refund) -> refund.status == 'pending_approval'
        return refund if refund
      null

    show_removed_order_items_section: ->
      @order &&
      @order.removed_order_items &&
      @order.removed_order_items.length > 0
  }

  created: ->
    @$store.dispatch 'order/fetch', @$route.params
    .then (order) =>
      @order = order
      @polling = true
      @begin_poll()
    .catch (error) -> console.error 'order/fetch caught:', error

  beforeDestroy: ->
    @polling = false
    clearTimeout @poll_timeout_id

  methods:
    formatted_time: (time) ->
      new DateTime.fromISO(time).toFormat('ff')

    number_to_currency: (int) ->
      "R #{(Number(int) / 100).toFixed(2)}"

    formatted_text: (string) ->
      text = String(string).split('_').join(' ')
      text[0].toUpperCase() + text.slice(1).toLowerCase()

    item_is_stock_short: (qty, qty_ordered) ->
      qty < qty_ordered

    order_is_pollable: ->
      @order? && @order.shipping_status not in ['delivered', 'collected']

    approve_refund: ->
      return unless window.confirm('Approve this refund? This will submit it to the payment provider.')

      @resolve_refund 'approve_refund'

    mark_order_completed: ->
      return unless window.confirm('Confirm that this order was completed and must not be refunded?')

      @resolve_refund 'completed'

    resolve_refund: (action) ->
      @refund_action = action
      @refund_message = null
      @$store.dispatch("order/#{action}", @order.id)
      .then (response) =>
        @order = response.order
        @refund_message = response.message
      .catch (error) =>
        if error.order
          @$store.commit 'order/set', error.order
          @order = error.order
        @refund_message = error.message if error.message
      .finally => @refund_action = null

    begin_poll: ->
      return unless @polling && @order_is_pollable()

      @poll_timeout_id = setTimeout =>
        return unless @polling && @order_is_pollable()

        @$store.dispatch 'order/fetch', @$route.params
        .then (order) => @order = order if order
        .catch (error) -> console.error 'order/poll caught:', error
        .finally => @begin_poll()
      , 10000
}
